<template>
  <div class="product-page">
    <div class="d-flex align-center justify-space-between">
      <div>
        <h1 class="my-0">Gifts</h1>
        <p>
          Offer customers to buy in a bulk of products with your attractive discount.
        </p>
      </div>
      <v-btn color="primary" @click="$router.push({ name: 'website.apps.gift.create' })"
        ><v-icon>mdi-plus</v-icon> Create offer</v-btn
      >
    </div>
    <Offer />
  </div>
</template>

<script>
import Offer from './components/Offer';
export default {
  components: {
    Offer,
  },
};
</script>
